var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5601 17.2733L9.05721 11.7761C9.38723 11.4461 9.55223 11.2811 9.74251 11.2193C9.90988 11.1649 10.0902 11.1649 10.2575 11.2193C10.4478 11.2811 10.6128 11.4461 10.9428 11.7761L16.4033 17.2366M11.6667 12.5L14.0572 10.1095C14.3872 9.77946 14.5522 9.61445 14.7425 9.55263C14.9099 9.49825 15.0902 9.49825 15.2575 9.55263C15.4478 9.61445 15.6128 9.77946 15.9428 10.1095L18.3334 12.5M8.33335 7.5C8.33335 8.42047 7.58716 9.16667 6.66669 9.16667C5.74621 9.16667 5.00002 8.42047 5.00002 7.5C5.00002 6.57953 5.74621 5.83333 6.66669 5.83333C7.58716 5.83333 8.33335 6.57953 8.33335 7.5ZM5.66669 17.5H14.3334C15.7335 17.5 16.4336 17.5 16.9683 17.2275C17.4387 16.9878 17.8212 16.6054 18.0609 16.135C18.3334 15.6002 18.3334 14.9001 18.3334 13.5V6.5C18.3334 5.09987 18.3334 4.3998 18.0609 3.86502C17.8212 3.39462 17.4387 3.01217 16.9683 2.77248C16.4336 2.5 15.7335 2.5 14.3334 2.5H5.66669C4.26656 2.5 3.56649 2.5 3.03171 2.77248C2.56131 3.01217 2.17885 3.39462 1.93917 3.86502C1.66669 4.3998 1.66669 5.09987 1.66669 6.5V13.5C1.66669 14.9001 1.66669 15.6002 1.93917 16.135C2.17885 16.6054 2.56131 16.9878 3.03171 17.2275C3.56649 17.5 4.26656 17.5 5.66669 17.5Z",
    stroke: "#155B75",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotos);
export default __webpack_public_path__ + "static/media/photos.fb246961f6f57a4fa44efa405cb5abab.svg";
export { ForwardRef as ReactComponent };